module.exports = __webpack_public_path__ + "img/index_logo.7bbfacab.png";